import { Component, OnInit } from '@angular/core';
import { AccountMixin } from 'src/app/services/mixins/account.mixin';
import { PageService } from 'src/app/services/page.service';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { InfoService } from 'src/app/services/info.service';
import { Observable } from 'rxjs';

import { Select } from '@ngxs/store';
import { UserState } from 'src/app/store/states/user.state';


import { PaymentService } from '@services/payment.service';

import { WindowRefService } from '@shared/window-ref';

import { BaseComponent } from '../../base.component';


@Component({
    selector: 'app-payment-success',
    templateUrl: './payment-success.component.html',

})
export class PaymentSuccessComponent extends AccountMixin(BaseComponent)
    implements OnInit {
    @Select(UserState.lastSign)
    public lastSign$: Observable<any | null>;

    @Select(UserState.data) public userData$: Observable<Record<string, any>>;

    public actualTime: any;


    public userData: Record<string, any>;

    private sessionId: string;

    public constructor(
        protected page: PageService,
        protected router: ActivatedRoute,
        public payment: PaymentService,
        protected win: WindowRefService,
        protected title?: Title,
        protected meta?: Meta,
        protected route?: Router,
        protected info?: InfoService,

    ) {
        super(page, title, meta, route, info);
    }

    public ngOnInit(): void {
        super.ngOnInit();

        this.router.queryParamMap.subscribe((param: ParamMap) => {
            if (param.has('session_id')) {
                this.sessionId = param.get('session_id') as string;

                this.payment.getTransactions(this.sessionId).subscribe((val) => {
                    if (val && Array.isArray(val) && val.length > 0) {
                        const product = val[0];
                        this.win.nativeWindow.dataLayer.push({ event: 'purchase',
                            ecommerce: {
                                currency: (product?.product?.currency as string).toUpperCase(), // currency code
                                value: product?.product?.amount,
                                items: [{
                                    item_name: typeof product?.product.permission === 'object'
                                        ? product?.product.permission.permission_name : '',
                                    item_id: product?.product?.id,
                                    price: product?.product?.amount,
                                    subscription: product?.product?.subscription_type,
                                    quantity: '1',
                                }] } });
                    }
                });
            }
        });

        this.userData$.subscribe(((val) => {
            this.userData = val;
        }));
    }
}
